import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { redirectToLogin } from '../../utils/auth-redirect';

/**
 * Protects routes that require authentication.
 * Redirects to AAD login if not authenticated.
 */
export function ProtectedRoute() {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
            </div>
        );
    }

    if (!isAuthenticated) {
        const returnPath = location.pathname + (location.search || '');
        redirectToLogin(returnPath);
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
            </div>
        );
    }

    return <Outlet />;
}
